/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonTable } from "../common/common-list/table/Table";
import { KTCard } from "../../../../_metronic/helpers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "../common/common-list/components/pagination/Pagination";
import { setId } from "../../../../redux/features/shared/sharedSlice";
import { TopupPacksModal } from "./TopupPacksModal";
import { UserListHeader } from "../common/common-list/components/header/UserListHeader";
import { topupPacksColumns } from "../common/common-list/table/columns/_topupPacksColumns";
import { getTopupPacks } from "../../../../redux/features/topupPacks/_topupPacksAction";

const TopupPacksList = () => {
  const dispatch: any = useDispatch();
  const totalRecord = useSelector((state: any) => state.topupPacksList?.totalRecord);
  const packList = useSelector((state: any) => state?.topupPacksList?.data);
  const sharedActions = useSelector((state: any) => state.sharedActions);

  useEffect(() => {
    dispatch(setId('TopupPack'))
    dispatch(getTopupPacks({ page: 1, limit: 10 }));
  }, [dispatch]);

  const handleClick = (page: number) => {
    dispatch(getTopupPacks({ page: page, limit: 10 }));
  };

  return (
    <>
      <KTCard>
        <UserListHeader />
        <CommonTable data={packList} columns={topupPacksColumns} />
        {sharedActions?.topupPacksModal &&
          <TopupPacksModal />
        }
        {totalRecord > 10 && <Pagination
          totalRecord={totalRecord}
          handleClick={handleClick}
        />}
      </KTCard>
    </>
  );
};

export { TopupPacksList };
